import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { RoleService } from '../../services/role/role.service';
import { Role } from '../../models/shared/role.model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';

@Component({
    selector: 'app-edit-role',
    templateUrl: './edit-role.component.html',
    styleUrls: ['./edit-role.component.css']
})
/** edit-role component*/
export class EditRoleComponent {
  role = new Role();
   /** edit-role ctor */
  constructor(private _avRoute: ActivatedRoute,
    private roleService: RoleService, private _router: Router,
    private readonly toastr: ToastsManager, vcr: ViewContainerRef, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("role").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0) {
            this.toastr.setRootViewContainerRef(vcr);
            if (this._avRoute.snapshot.params["id"]) {
              this.getRoleById(this._avRoute.snapshot.params["id"]);
            }
          }
          else {
            this._router.navigate(["/role-lis"]);
          }
        }
        else {
          this._router.navigate(["/role-lis"]);
        }
      }
    )
  }

  getRoleById(id: string) {
    this.roleService.GetRoleById(id).subscribe(
      data => {
        this.role = data;
      }
    )
  }

  onSubmit() {
    this.toastr.success('Role has been updated', 'Success');
    this.roleService.UpdateRole(this.role);
  }
}



// WEBPACK FOOTER //
// ./src/app/role-components/edit-role/edit-role.component.ts